<template>
  <div class="w-full">
    <h2 class="text-2xl text-primary leading-10 font-inter font-bold tracking-tight mb-6">
      Church Life
    </h2>
    <div class="flex flex-col gap-6">
      <ChurchLifeRequestCard :payload="payload" :cgData="cgData" />
    </div>
  </div>
</template>
<script>
import ChurchLifeRequestCard from './ChurchLifeRequestCard.vue';
export default {
  components: {
    ChurchLifeRequestCard,
  },
  props: {
    payload: {
      type: Object,
      default: {},
    },
    cgData: {
      type: Object,
      default: {},
    },
  },
};
</script>
